<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href="route_back">Список организаций</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактирование организации</li>
        </ol>
    </nav>

    <div class="col-md-4 col-12">
        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="input_name_client_id">Клиент <span class="color-red">*</span></label>
                <v-select
                    class="select"
                    v-model="client_id"
                    :items="clients"
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                >
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="org-name">Название организации <span class="color-red">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    id="org-name"
                    v-model="name"
                    placeholder="Введите название организации"
                >
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="org-inn">ИНН организации <span class="color-red">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    id="org-inn"
                    v-model="inn"
                    placeholder="Введите ИНН организации"
                    maxlength="10"
                    @input="filterDigits('inn')"
                >
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="org-kpp">КПП организации <span class="color-red">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    id="org-kpp"
                    v-model="kpp"
                    placeholder="Введите КПП организации"
                    maxlength="9"
                    @input="filterDigits('kpp')"
                >
            </div>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="updateOrg" />
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>
import { mapMutations } from "vuex/dist/vuex.cjs.js";
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Organization from "../../../../models/Organization";
import Alert from "../../../alerts/Alert.vue";

export default {
    name: "OrganizationEditComponent",
    components: { ConfirmBtn, Alert },
    props: {
        route_back: String,
        route_client_search: String,
        route_update: String,
        route_get: String,
        item_id: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {
            organization: new Organization({
                route_update: this.route_update,
                route_client_search: this.route_client_search,
                route_create: this.route_create,
                route_get: this.route_get
            }),
            clients: [],
            client_id: 0,
            name: '',
            inn: '',
            kpp: ''
        };
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),

        async itemGet() {
            this.item = await this.organization.get(this.item_id);
            this.client_id = this.item.client_id;
            this.inn = this.item.inn;
            this.kpp = this.item.kpp;
            this.name = this.item.name;
        },

        async searchClients() {
            let clients = await this.organization.clients();
            this.clients = clients.items;
        },

        selectItem(id) {
            console.log(id);
        },

        filterDigits(field) {
            // Разрешаем только цифры
            this[field] = this[field].replace(/\D/g, '');
        },

        async updateOrg() {
            if (!this.client_id) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите клиента!' });
                this.toggleLoading();
                return;
            }

            if (this.name.trim() === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название организации!' });
                this.toggleLoading();
                return;
            }

            if (this.inn.toString().length !== 10) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'ИНН организации должен содержать ровно 10 цифр!' });
                this.toggleLoading();
                return;
            }

            if (this.kpp.toString().length !== 9) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'КПП организации должен содержать ровно 9 цифр!' });
                this.toggleLoading();
                return;
            }

            let result = await this.organization.update({
                client_id: this.client_id,
                inn: this.inn,
                kpp: this.kpp,
                name: this.name,
            }, this.item_id);

            if (result) {
                window.location.href = this.route_back;
            } else {
                console.log('error: update_organization');
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Ошибка редактирования организации!' });
                this.toggleLoading();
            }
        }
    },
    mounted() {
        this.searchClients();
        this.itemGet();
    }
};
</script>

<style scoped>

</style>
